module.exports = {
  siteMetadata: {
    title: 'The Path Forward on Guns',
  },
  plugins: [
    'gatsby-plugin-emotion',
    'gatsby-plugin-react-helmet',
    {
      resolve: 'gatsby-plugin-favicon',
      options: {
        logo: './src/images/favicon-tight-crop.png',
        injectHTML: true,
        icons: {
          android: true,
          appleIcon: true,
          appleStartup: true,
          coast: false,
          favicons: true,
          firefox: true,
          twitter: false,
          yandex: false,
          windows: true,
        },
      },
    },
    {
      resolve: 'gatsby-plugin-google-analytics',
      options: {
        trackingId: 'UA-115888857-1',
        // Puts tracking script in the head instead of the body
        head: true,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./gatsby-config.js